// =============================================================================
// useCanOpenFarmPieceRates — would the /farm/piecework-config route let this
// person in? (FM04 UF-14 · UF-14b)
//
// The farm rates page used to sit behind Farm Config alone. A farm manager
// whom a custom role left without it was sent to "set the missing rate" on a
// page that bounced him to Home without a word, though set_piece_rate admits
// can_manage_labour(). Now the page admits:
//
//   · a Farm Config holder, as before; OR
//   · anyone who holds Farm Labour. A labour manager (farm_labour: manage)
//     adds, edits and ends rates; anyone else with Farm Labour — the foreman —
//     opens the page READ-ONLY (UF-14b, approved against the page's lean):
//     every rate, each picker's own included. That is wage data, so the page
//     masks each amount while money is locked, and renders no edit control.
//
// ONE answer for the route guard (App.tsx gFarmPieceRates) and every pointer to
// the page, so a link is offered exactly when the route would open. null while
// any read is still deciding — the route gate's isPending rule (finding H4).
// =============================================================================

import { useCanOpenModule } from '@/hooks/useCanOpenModule'
import { useActiveTenant } from '@/lib/useActiveTenant'

export const FARM_PIECE_RATES_PATH = '/farm/piecework-config'

/** The rule, pure. */
export function farmPieceRatesRouteAdmits(a: {
  canOpenConfig: boolean
  canOpenLabour: boolean
  tenantKind:    string | null | undefined
}): boolean {
  return a.tenantKind === 'FARM' && (a.canOpenConfig || a.canOpenLabour)
}

export function useCanOpenFarmPieceRates(): boolean | null {
  const canOpenConfig = useCanOpenModule('farm_config')
  const canOpenLabour = useCanOpenModule('farm_labour')
  const { data: tenant, isPending: tenantPending } = useActiveTenant()
  if (canOpenConfig === null || canOpenLabour === null || tenantPending) return null
  return farmPieceRatesRouteAdmits({ canOpenConfig, canOpenLabour, tenantKind: tenant?.kind })
}
